/* eslint-disable no-undef */
/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Switch, Route, BrowserRouter } from 'react-router-dom';
import { Layout } from 'ui/components';
import { useLocation } from 'react-router';
import _ from 'underscore';

// Read subrouter in each subfolder
let routes = [];
const rf = require.context('./', true, /^.*_subrouter.js$/);
rf.keys().forEach((fileName) => {
  routes = routes.concat(rf(fileName).default);
});

const AuthorizedRouter = () => {
  const session = useSelector((state) => state?.Auth?.session);

  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split('/');

  let redirect = <Redirect exact from="/*" to="/delivery/plan" />;

  return (
    <BrowserRouter>
      <Layout>
        {splitLocation[1] === 'print' ? null : (
          <Layout.Header sticky fluid consended />
        )}
        <Layout.Body>
          <Switch>
            {routes.map((d, i) => {
              let comp = null;
              if (session?.privileges) {
                let x = _.findWhere(session?.privileges, {
                  service: d?.service,
                });
                if (d?.path === '/profile/setting') {
                  comp = (
                    <Route
                      key={i}
                      exact
                      path={d.path}
                      component={d.component}
                    />
                  );
                }

                if (x) {
                  if (d?.action?.includes(x?.action)) {
                    comp = (
                      <Route
                        key={i}
                        exact
                        path={d.path}
                        component={d.component}
                      />
                    );
                    let receiving = _.findWhere(session?.privileges, {
                      module: 'receiving',
                    });
                    let fulfillment = _.findWhere(session?.privileges, {
                      module: 'fulfillment',
                    });
                    let stockopname = _.findWhere(session?.privileges, {
                      module: 'stockopname',
                    });
                    let stock = _.findWhere(session?.privileges, {
                      module: 'stock',
                    });
                    let item = _.findWhere(session?.privileges, {
                      module: 'item',
                    });

                    if (receiving) {
                      redirect = <Redirect exact from="/*" to="/receiving" />;
                    } else if (fulfillment) {
                      redirect = <Redirect exact from="/*" to="/fulfillment" />;
                    } else if (stockopname) {
                      redirect = <Redirect exact from="/*" to="/stockopname" />;
                    } else if (stock) {
                      redirect = <Redirect exact from="/*" to="/stock" />;
                    } else if (item) {
                      redirect = <Redirect exact from="/*" to="/item" />;
                    }
                  }
                }
              } else {
                comp = (
                  <Route key={i} exact path={d.path} component={d.component} />
                );
              }
              return comp;
              // return (
              //   <Route key={i} exact path={d.path} component={d.component} />
              // );
            })}

            {redirect}
          </Switch>
        </Layout.Body>
      </Layout>
    </BrowserRouter>
  );
};

export default AuthorizedRouter;
